import axios, {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  CreateAxiosDefaults,
  InternalAxiosRequestConfig,
} from 'axios';

/**
 * AI.GEN lines=1-52
 * 请求基类
 */
export interface RequestBaseOptions extends CreateAxiosDefaults {}

/**
 * 请求基类
 * 提供基础的 axios 实例和拦截器功能
 */
export class RequestBase {
  axios: AxiosInstance;

  get: AxiosInstance['get'];
  post: AxiosInstance['post'];
  put: AxiosInstance['put'];
  delete: AxiosInstance['delete'];
  patch: AxiosInstance['patch'];
  options: AxiosInstance['options'];

  constructor(options: RequestBaseOptions = {}) {
    this.axios = axios.create(options);
    this.axios.interceptors.request.use(
      this.requestInterceptorFulfilled.bind(this),
    );
    this.axios.interceptors.response.use(
      this.responseInterceptorFulfilled.bind(this),
      this.responseInterceptorRejected.bind(this),
    );

    this.get = this.axios.get;
    this.post = this.axios.post;
    this.put = this.axios.put;
    this.delete = this.axios.delete;
    this.patch = this.axios.patch;
    this.options = this.axios.options;
  }

  /**
   * 请求拦截器成功回调
   * @param config 请求配置
   * @returns 请求配置
   */
  requestInterceptorFulfilled(
    config: InternalAxiosRequestConfig,
  ): InternalAxiosRequestConfig {
    return config;
  }

  /**
   * 响应拦截器成功回调
   * @param response 响应对象
   * @returns 响应对象
   */
  responseInterceptorFulfilled(response: AxiosResponse): AxiosResponse {
    return response;
  }

  /**
   * 响应拦截器失败回调
   * @param error 错误对象
   * @returns Promise.reject
   */
  responseInterceptorRejected(error: AxiosError): Promise<AxiosError> {
    return Promise.reject(error);
  }
}
